import { makeVar } from '@apollo/client'

/** Demo rounds the guest session holds per mode, read when the claim is offered. */
export interface GuestDemoRounds {
  upDownAi: number
  bullseye: number
  upDown: number
}

export const EMPTY_GUEST_DEMO_ROUNDS: GuestDemoRounds = {
  upDownAi: 0,
  bullseye: 0,
  upDown: 0
}

export const guestDemoRoundsVar = makeVar<GuestDemoRounds>(
  EMPTY_GUEST_DEMO_ROUNDS
)

/**
 * The signed-in user whose post-sign-in check (`useMergeGuestSession`) is
 * done: nothing to claim, the silent merge finished, or the claim dialog was
 * opened. `null` until then and after a sign-out. Read through
 * `useIsGuestMergeSettled`, which also waits for the dialog to close.
 */
export const guestMergeCheckedForVar = makeVar<string | null>(null)

/**
 * This visitor's guest session (FE-321), read or created once per page load
 * and shared by the analytics identity and the demo modes; `null` until then.
 */
export const guestSessionIdVar = makeVar<string | null>(null)

/**
 * The gateway refused to create a guest session (20 per IP per hour); not
 * retried in this page load.
 */
export const isGuestSessionRefusedVar = makeVar(false)
